module.exports = __webpack_public_path__ + "img/email-de.ba626e90.jpg";